<template>
  <div
    style="background: #ddd"
    v-if="
      this.eventi &&
        (this.eventi.length > 1 ||
          (this.eventi.length == 1 &&
            this.eventi[0].Channel.Status == 'CLOSED')) &&
        loaded
    "
    id="event-main"
    role="main"
  >
    <div
      @click="loadEvents()"
      v-on:keyup.enter="loadEvents()"
      class="aggiorna"
      tabindex="0"
      :aria-label="$t('event-selection.page-update')"
    >
      <md-icon class="md-size-min" aria-hidden="true">refresh</md-icon>
      {{ $t("event-selection.page-update") }}
    </div>
    <md-card
      :md-with-hover="
        evento.Channel != null && evento.Channel.Status !== 'CLOSED'
      "
      v-for="evento in eventi"
      :key="evento.ElectionEvent.EventIdentifier.Id"
      v-bind:class="
        evento.Channel != null && evento.Channel.Status == 'CLOSED'
          ? 'evt-chiuso'
          : ''
      "
      :aria-label="
        evento.Channel != null && evento.Channel.Status == 'CLOSED'
          ? 'stato evento chiuso'
          : ''
      "
    >
      <div
        @click="loadEvent(evento)"
        v-on:keyup.enter="loadEvent(evento)"
        class="evt-card"
        :tabindex="
          evento.Channel != null && evento.Channel.Status == 'CLOSED' ? -1 : 0
        "
        :disabled="evento.Channel != null && evento.Channel.Status == 'CLOSED'"
        :aria-disabled="
          evento.Channel != null && evento.Channel.Status == 'CLOSED'
        "
      >
        <img
          class="customimg logo"
          v-bind:src="
            'data:image/jpeg;base64,' +
              evento.ElectionEvent.EventLogo.Binary.value
          "
          aria-hidden="true"
          role="presentation"
          alt="Logo uVote"
          v-if="!isMobile && evento.ElectionEvent.EventLogo.Binary.value"
        />
        <div>
          <md-card-header>
            <div class="md-title" role="heading" aria-level="1">
              <span class="screenreader"
                >{{ $t("election-event.screen-reader.title") }}:
              </span>
              {{ evento.ElectionEvent.EventIdentifier.EventName }}
            </div>
            <div class="md-subhead">
              <span class="screenreader">{{
                $t("election-event.screen-reader.from-date")
              }}</span>
              <span
                class="md-caption md-caption-black"
                style="color:black;"
                v-if="
                  evento.ElectionEvent.EventDate !== null &&
                    evento.ElectionEvent.EventDate.Start
                "
              >
                {{ evento.ElectionEvent.EventDate.Start }}
              </span>
              <span class="screenreader">{{
                $t("election-event.screen-reader.to-date")
              }}</span>
              <span
                class="md-caption md-caption-black"
                style="color:black;"
                v-if="
                  evento.ElectionEvent.EventDate !== null &&
                    evento.ElectionEvent.EventDate.End
                "
              >
                -
                {{ evento.ElectionEvent.EventDate.End }}
              </span>
            </div>
          </md-card-header>

          <md-card-content>
            <div>
              <b>{{ $t("event-selection.status") }}: </b>
              <span
                :class="evento.Channel != null ? evento.Channel.Status : ''"
                >{{
                  evento.Channel != null && evento.Channel.Status == "CLOSED"
                    ? $t("event-selection.closed-status")
                    : $t("event-selection.open-status")
                }}</span
              >
            </div>
            <div
              v-if="
                evento.Channel != null &&
                  evento.Channel.Status == 'CLOSED' &&
                  evento.UnauthorizedMessage &&
                  evento.UnauthorizedMessage.length > 0
              "
            >
              <span :class="evento.Channel != null ? evento.Channel.Status : ''"
                ><b class="bold"
                  >{{ $t("session-already-open-dialog.title") }}:
                </b>
                {{ evento.UnauthorizedMessage }}</span
              >
            </div>

            <div v-if="evento.Channel != null && evento.Channel.OpeningTime">
              <b aria-hidden="true" role="presentation">
                {{ $t("event-selection.time") }}:
              </b>
              <span class="screenreader">{{ $t("footer.calendar") }}</span>
              <span
                style="letter-spacing: -0.5px"
                v-for="(day, index) in evento.Channel.OpeningTime.Day"
                v-bind:key="day.Date"
              >
                <md-icon
                  class="md-size-min"
                  aria-hidden="true"
                  role="presentation"
                  >calendar_month</md-icon
                >
                {{ formatDate(day) }}
                <span v-if="index != evento.Channel.OpeningTime.Day.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div
              v-if="
                evento.HelpDeskInformation.ContactInformation[
                  'e-mailAddress'
                ] ||
                  evento.HelpDeskInformation.ContactInformation.PhoneNumber ||
                  evento.HelpDeskInformation.ContactInformation.URL
              "
            >
              <b>{{ $t("footer.contacts") }}: </b>
              <span
                v-if="
                  evento.HelpDeskInformation.ContactInformation['e-mailAddress']
                "
              >
                <md-icon class="md-size-min" aria-label="mail"> mail</md-icon>
                <span class="screenreader">
                  {{
                    evento.HelpDeskInformation.ContactInformation[
                      "e-mailAddress"
                    ].replace(/-/g, "trattino")
                  }}
                </span>
                <a
                  v-on:click.stop="
                    goToMail(
                      evento.HelpDeskInformation.ContactInformation[
                        'e-mailAddress'
                      ]
                    )
                  "
                  aria-hidden="true"
                >
                  {{
                    evento.HelpDeskInformation.ContactInformation[
                      "e-mailAddress"
                    ]
                  }}</a
                >
              </span>
              <span
                v-if="
                  evento.HelpDeskInformation.ContactInformation[
                    'e-mailAddress'
                  ] && evento.HelpDeskInformation.ContactInformation.PhoneNumber
                "
                >,</span
              >
              <span
                v-if="evento.HelpDeskInformation.ContactInformation.PhoneNumber"
              >
                <span class="screenreader">{{ $t("footer.telephone") }}</span>
                <md-icon
                  class="md-size-min"
                  aria-hidden="true"
                  role="presentation"
                >
                  call</md-icon
                >
                {{
                  evento.HelpDeskInformation.ContactInformation.PhoneNumber[0]
                }}</span
              >
              <span
                v-if="
                  evento.HelpDeskInformation.ContactInformation.URL &&
                    (evento.HelpDeskInformation.ContactInformation[
                      'e-mailAddress'
                    ] ||
                      evento.HelpDeskInformation.ContactInformation.PhoneNumber)
                "
                >,</span
              >

              <span v-if="evento.HelpDeskInformation.ContactInformation.URL">
                <span class="screenreader">{{ $t("footer.website") }}</span>
                <md-icon
                  class="md-size-min"
                  aria-hidden="true"
                  role="presentation"
                >
                  language</md-icon
                >
                <a
                  v-on:click.stop="
                    goToLink(evento.HelpDeskInformation.ContactInformation.URL)
                  "
                >
                  {{ evento.HelpDeskInformation.ContactInformation.URL }}</a
                >
              </span>
            </div>
            <div>
              <b>{{ $t("event-selection.enabled-languages") }}:</b>
              {{ lingue(evento.EnabledLanguage) }}
            </div>
          </md-card-content>
        </div>
      </div>
    </md-card>
    <br /><br />
    <div
      style="border-top: 1px solid #fff; padding-bottom: 20px; margin: 0 20px"
    ></div>
    <Accesibility></Accesibility>
    <br /><br />

    <div
      id="cookie-container"
      class="cookie-container"
      v-if="loaded && cookieBanner"
    >
      <div>
        <h2 class="cookie-title">{{ $t("footer.cookie.title") }}</h2>
      </div>
      <p class="text-align">
        {{ $t("footer.cookie.p")
        }}<span
          v-if="
            $store.state.electionEvent != null &&
              $store.state.electionEvent.cookieLink1 != null
          "
          >,
          <a
            :href="$store.state.electionEvent.cookieLink1"
            class="acc-link"
            target="_blank"
            rel="noopener noreferrer"
            >{{ $t("footer.cookie.here-link") }}</a
          ></span
        >{{ $t("footer.cookie.p2")
        }}<span
          v-if="
            $store.state.electionEvent != null &&
              $store.state.electionEvent.cookieLink2 != null
          "
          >,
          <a
            :href="$store.state.electionEvent.cookieLink2"
            class="acc-link"
            target="_blank"
            rel="noopener noreferrer"
            >{{ $t("footer.cookie.here-link") }}</a
          ></span
        >.
      </p>
      <div class="button-container">
        <div></div>
        <div class="right">
          <md-button
            aria-label="Ok"
            class="cookie-ok-button"
            @click="cookieOk()"
          >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              style="z-index: 30"
              >{{ $t("footer.cookie.ok-button") }}
            </md-tooltip>
            {{ $t("footer.cookie.ok-button") }}</md-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import Accesibility from "./Accesibility";

import Utils from "../utils/Utils.js";
import i18n from "../i18n";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
    this.cookieContainer = document.querySelector(".cookie-container");
    if (this.getCookie("COOKIE_BANNER_OK")) {
      this.cookieBanner = false;
      /* if (document.getElementById("cookie-container") != null) {
          document
            .getElementById("cookie-container")
            .setAttribute("aria-hidden", "true");
          document.getElementById("cookie-container").style.display = "none";
        } */
    }
    this.loadEvents();
  },
  data: function() {
    return {
      alertMessage: "",
      isMobile: false,
      eventi: null,
      loaded: false,
      cookieBanner: true,
      countLoadEvent: 0
    };
  },
  props: [],
  methods: {
    goToLink(url) {
      if (!url.includes("http")) url = "http://" + url;
      window.open(url, "_blank").focus();
    },
    goToMail(url) {
      window.open("mailto:" + url, "mail");
    },
    async loadEvents() {
      this.loaded = false;
      this.$emit("electionsListLoading");

      const response = await this.$store.state.ceoCbbService.getElectionEvents();
      this.eventi = response.ElectionEventInformations;

      if (response.LogoutUrl) {
        this.$store.commit(
          "logoutUrlSetter",
          this.$store.state.ceoCbbService.getLogoutUrl()
        );

        this.$store.state.ceoCbbService.specificLogoutUrlSetter(
          response.LogoutUrl
        );
      }

      this.$emit("electionsListRetrieved");
      this.loaded = true;

      if (
        this.eventi.length == 1 &&
        this.eventi[0].Channel.Status == "OPEN_FOR_VOTING"
      ) {
        this.loadEvent(this.eventi[0]);
      }

      this.$store.commit("eventNumberSetter", this.eventi.length);
      this.checkOpening();
    },
    formatDate(date) {
      let options = { weekday: "short", day: "numeric", month: "short" };

      let day = Intl.DateTimeFormat(this.$i18n.locale, options).format(
        new Date(this.convertDate(date.Date))
      );

      options = { hour: "2-digit", minute: "2-digit" };

      let from = Intl.DateTimeFormat(this.$i18n.locale, options).format(
        new Date(this.convertDate(date.From))
      );

      let to = Intl.DateTimeFormat(this.$i18n.locale, options).format(
        new Date(this.convertDate(date.To))
      );

      return day[0].toUpperCase() + day.substring(1) + " " + from + " - " + to;
    },
    convertDate(date) {
      var values = date.split(/[^0-9]/),
        year = parseInt(values[0], 10),
        month = parseInt(values[1], 10) - 1, // Month is zero based, so subtract 1
        day = parseInt(values[2], 10),
        hours = parseInt(values[3], 10),
        minutes = parseInt(values[4], 10),
        seconds = parseInt(values[5], 10);

      let formattedDate = new Date(year, month, day, hours, minutes, seconds);
      return formattedDate;
    },
    lingue(lang) {
      let res = "";
      lang?.forEach(l => {
        let lang =
          l === "it"
            ? this.$i18n.t("event-selection.italian")
            : l === "en"
            ? this.$i18n.t("event-selection.english")
            : l === "de"
            ? this.$i18n.t("event-selection.german")
            : l;
        res = res + lang + ", ";
      });
      return res.slice(0, -2);
    },
    checkOpening() {
      let todaysDate = new Date();
      this.eventi.forEach(eve => {
        if (
          eve.Channel != null &&
          eve.Channel.Status == "CLOSED" &&
          eve.Channel.OpeningTime?.Day
        ) {
          eve.Channel.OpeningTime?.Day.forEach(day => {
            let inputDate = new Date(this.convertDate(day.Date));
            if (
              inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)
            ) {
              let hour = new Date(this.convertDate(day.From))
                .toLocaleTimeString()
                .split(":");
              let hourToCheck = new Date(this.convertDate(day.Date)).setHours(
                hour[0],
                hour[1],
                hour[2]
              );
              //console.log("xxx: checkOpening -> todaysDate", new Date());

              //console.log("xxx: checkOpening -> hourToCheck",new Date(hourToCheck));

              var diff = new Date() - new Date(hourToCheck);
              var minutes = Math.floor(diff / 1000 / 60);
              //console.log("xxx: checkOpening -> minutes", minutes);

              //se è passata l'apertura ma ancora è chiuso l'evento ricarichiamo  dopo 2 minuti
              if (minutes >= 0 && minutes <= 15) {
                minutes = -1;
                diff = 60000;
              }

              if (minutes < 0 && minutes >= -15) {
                setTimeout(() => {
                  this.loadEvents();
                }, Math.abs(diff) + 60000);
              }
            }
          });
        }
      });
    },
    async loadEvent(evt) {
      //this.$emit("identityNotRetrieved");
      this.countLoadEvent++;
      if (this.countLoadEvent == 1) {
        //solo il primo clic sull'evento funziona
        if (evt.Channel.Status == "CLOSED") return;

        //CARICO IL VOTER
        let voterIdentification = await this.$store.state.ceoCbbService.voterIdentification(
          evt.ElectionEvent.EventIdentifier.Id,
          evt.voterId
        );

        if (voterIdentification.error) {
          alert(
            voterIdentification.error + "\n\n" + this.$store.state.alertMessage
          );
          if (this.$store.state.logoutUrl) {
            const url = this.$store.state.logoutUrl;
            this.$store.replaceState({});
            window.location.href = url;
          } else {
            this.$store.replaceState({});
            this.$keycloak.logoutFn();
          }
        } else {
          this.$store.commit("voterIdentificationSetter", voterIdentification);
          //this.$emit("identityRetrieved");
        }

        //Controllo che la lingua selezionata sia tra quelle disponibili
        if (
          voterIdentification.EnabledLanguage &&
          !voterIdentification.EnabledLanguage.includes(this.$i18n.locale)
        ) {
          if (voterIdentification.Voter.VoterInformation.PreferredLanguage)
            this.$i18n.locale =
              voterIdentification.Voter.VoterInformation.PreferredLanguage;
          else this.$i18n.locale = voterIdentification.EnabledLanguage[0];
        }

        // CARICO L'EVENTO
        let electionEvent = await this.$store.state.ceoCbbService.getElectionEvent(
          evt.ElectionEvent.EventIdentifier.Id,
          evt.voterId
        );
        this.$emit("eventSelected", "UVOTE2");

        if (electionEvent.error) {
          alert(electionEvent.error + "\n\n" + this.$store.state.alertMessage);
          return;
        } else this.$store.commit("electionEventSetter", electionEvent);

        if (
          electionEvent.HelpDeskInformation != null &&
          electionEvent.HelpDeskInformation.ContactInformation != null &&
          electionEvent.HelpDeskInformation.ContactInformation.PhoneNumber !=
            null
        ) {
          this.$store.commit(
            "alertMessageSetter",
            i18n.t("error.support-contact") +
              "\n" +
              i18n.t("error.telephone") +
              ": " +
              electionEvent.HelpDeskInformation.ContactInformation.PhoneNumber
          );
          this.$store.state.ceoCbbService.alertContactsSetter(
            this.$store.state.alertMessage
          );
          if (
            electionEvent.HelpDeskInformation.ContactInformation[
              "e-mailAddress"
            ] != null
          ) {
            this.$store.commit(
              "alertMessageSetter",
              i18n.t("error.support-contact") +
                "\n" +
                i18n.t("error.telephone") +
                ": " +
                electionEvent.HelpDeskInformation.ContactInformation
                  .PhoneNumber +
                "\nE-mail: " +
                electionEvent.HelpDeskInformation.ContactInformation[
                  "e-mailAddress"
                ]
            );
            this.$store.state.ceoCbbService.alertContactsSetter(
              this.$store.state.alertMessage
            );
          }
        }
      }
    },
    cookieOk() {
      /* var expires = "";
      var date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString(); */
      document.cookie =
        "COOKIE_BANNER_OK=true" + /* expires + */ "; path=/; Secure";

      document
        .getElementById("cookie-container")
        .setAttribute("aria-hidden", "true");
      document.getElementById("cookie-container").style.display = "none";
      //this.$emit("cookieBannerOk");
    },
    getCookie(name) {
      let cookie = {};
      document.cookie.split(";").forEach(function(el) {
        let [k, v] = el.split("=");
        cookie[k.trim()] = v;
      });

      return cookie[name];
    }
  },
  components: {
    Accesibility
  }
};
</script>
<style scoped>
.md-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
  text-align: left;
  margin: 30px 20px -10px 20px;
  border-radius: var(--br);
  border: 2px solid var(--pcolor);
}
.CLOSED {
  color: #b50000;
  font-weight: bold;
}

.OPEN_FOR_VOTING {
  color: green;
  font-weight: bold;
}
.evt-chiuso {
  background-color: #eee !important;
  border: 2px solid #bbb !important;
}

.evt-card {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  align-items: center;
}

.evt-card b {
  font-weight: 500;
}
.evt-card img {
  padding-left: 20px;
  width: 110px;
}

a {
  color: #333 !important;
}
a:hover {
  color: #448aff !important;
}

.md-card .md-subhead {
  opacity: 0.7;
}

.md-icon.md-size-min {
  width: 14px;
  min-width: 14px;
  height: 14px;
  font-size: 14px !important;
  margin-top: -2px;
  transition: none;
  color: var(
    --md-theme-default-icon-on-background,
    rgba(0, 0, 0, 0.6)
  ) !important;
}

.aggiorna {
  cursor: pointer;
  margin-top: 15px;
  display: inline-block;
}

.aggiorna:hover,
.aggiorna:hover .md-icon.md-size-min {
  color: #448aff;
}

.evt-chiuso img {
  filter: gray; /* IE6-9 */
  -webkit-filter: grayscale(1); /* Google Chrome, Safari 6+ & Opera 15+ */
  filter: grayscale(1); /* Microsoft Edge and Firefox 35+ */
}

.cookie-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(178, 175, 175, 0.93);
  box-shadow: 0 -0.05px 4px rgba(21, 27, 31, 0.712);
  padding: 0 32px;
  transition: 400ms;
  z-index: 2;
}

.cookie-container a {
  color: blue;
}

.cookie-title {
  display: flex;
}

.text-align {
  text-align: initial;
}
.cookie-ok-button {
  background-color: #ffffff;
  float: right;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
  border-radius: var(--br);
}

.cookie-btn {
  display: flex;
  justify-content: flex-end;
  background: red;
  border: 0;
  padding: 12px 48px;
  font-size: 18px;
  margin-bottom: 16px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 0 1px 1px rgb(151, 217, 248);
}

.bold {
  font-weight: bold !important;
}

/* .md-card-header .md-subhead .md-caption {
  xcolor: #7a7575;
} */
/* @media screen and (max-width: 768px) {
  .evt-card img {
    display: none;
  }
} */
</style>
